(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passion-corporate-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-section-id]');
    sections.forEach((section) => {
      if (!section.classList.contains('pb-corp')) return;

      const tabsNav = section.querySelector('[data-pb-corp-tabs]');
      if (tabsNav) {
        const tabs = tabsNav.querySelectorAll('.pb-corp__tab');
        const cats = section.querySelectorAll('[data-pb-corp-cat]');
        const showCat = (targetId) => {
          cats.forEach((c) => c.classList.toggle('is-active', '#' + c.id === targetId));
          tabs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('href') === targetId));
        };
        const scrollToFirstCard = (targetId) => {
          const targetCat = section.querySelector(targetId);
          if (!targetCat) return;
          /* Wait one frame so the freshly-shown category is laid out before measuring */
          requestAnimationFrame(() => {
            const header = document.querySelector('#header-component');
            const headerH = header ? header.offsetHeight : 0;
            const tabsH = tabsNav.offsetHeight || 0;
            /* Land the user right above the first card with the sticky tab bar pinned just under the header */
            const firstCard = targetCat.querySelector('.pb-corp__card') || targetCat;
            const offset = headerH + tabsH + 16;
            const y = firstCard.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          });
        };
        tabs.forEach((tab) => tab.addEventListener('click', (e) => {
          e.preventDefault();
          const href = tab.getAttribute('href');
          showCat(href);
          scrollToFirstCard(href);
        }));
      }

      section.querySelectorAll('[data-pb-corp-card]').forEach((card) => {
        const isPackage = card.dataset.mode === 'package';
        const unitPrice = parseFloat(card.dataset.unitPrice || '0');
        const setupFee = parseFloat(card.dataset.setupFee || '0');
        const variantSelect = card.querySelector('[data-pb-corp-variant]');
        const qtyInput = card.querySelector('[data-pb-corp-qty]');
        const totalEl = card.querySelector('[data-pb-corp-total]');
        const addBtn = card.querySelector('[data-pb-corp-add]');

        const getUnitPrice = () => {
          if (variantSelect && variantSelect.selectedOptions.length) {
            const v = parseFloat(variantSelect.selectedOptions[0].dataset.price || '0');
            if (!Number.isNaN(v) && v > 0) return v;
          }
          return unitPrice;
        };
        const computeTotal = () => {
          const qty = Math.max(parseInt(qtyInput?.value || '1', 10) || 1, 1);
          const sub = qty * getUnitPrice();
          return isPackage ? sub + setupFee : sub;
        };
        const fmt = (n) => '$' + (Math.round(n * 100) / 100).toFixed(2);
        const refresh = () => { if (totalEl) totalEl.textContent = fmt(computeTotal()); };
        [variantSelect, qtyInput].filter(Boolean).forEach((el) => el.addEventListener('input', refresh));
        refresh();

        addBtn?.addEventListener('click', async () => {
          const variantId = (variantSelect && variantSelect.value) || card.dataset.variantId || '';
          const qty = Math.max(parseInt(qtyInput?.value || '1', 10) || 1, 1);
          const title = card.dataset.title || 'Item';
          if (!variantId) {
            const inquiryEmail = section.dataset.pbCorpInquiryEmail || 'orders@passionbake.com';
            const subject = encodeURIComponent('Corporate Order - ' + title);
            const body = encodeURIComponent('Hi Passion Bake team,\n\nI would like to order:\n\n  Item: ' + title + '\n  Quantity: ' + qty + (isPackage ? '\n  Setup fee: ' + fmt(setupFee) : '') + '\n  Estimated total: ' + fmt(computeTotal()) + '\n\nPlease confirm availability and timing.\n\nThanks!');
            window.location.href = 'mailto:' + inquiryEmail + '?subject=' + subject + '&body=' + body;
            return;
          }
          addBtn.disabled = true;
          const originalText = addBtn.textContent;
          addBtn.textContent = 'Adding...';
          try {
            const items = [{ id: parseInt(variantId, 10), quantity: qty }];
            if (isPackage && card.dataset.setupVariantId) {
              items.push({ id: parseInt(card.dataset.setupVariantId, 10), quantity: 1 });
            }
            /* Use Shopify's standard /cart/add.js — accepts items array, returns updated items */
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!addRes.ok) {
              const errBody = await addRes.json().catch(() => ({}));
              throw new Error(errBody.description || errBody.message || 'Add failed (' + addRes.status + ')');
            }
            const addedData = await addRes.json();
            /* Fetch the updated cart so the cart drawer / icon can render fresh state */
            const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            const cartData = cartRes.ok ? await cartRes.json() : null;

            /* Fire Horizon's native cart:update event so cart-drawer.js and cart-icon.js refresh */
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cartData,
                sourceId: section.id || 'pb-corp',
                data: {
                  source: 'pb-corp-menu',
                  itemCount: cartData ? cartData.item_count : qty,
                  variantId: String(variantId),
                  didError: false
                }
              }
            }));

            /* Try to open the cart drawer if the theme exposes one */
            const cartDrawer = document.querySelector('cart-drawer-component')
              || document.querySelector('cart-drawer')
              || document.querySelector('[ref="cartDrawer"]');
            if (cartDrawer) {
              const dialog = cartDrawer.querySelector('dialog');
              if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
                try { dialog.showModal(); } catch (e) { /* showModal can throw if already open */ }
              } else if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else if (typeof cartDrawer.show === 'function') {
                cartDrawer.show();
              }
            }

            addBtn.textContent = 'Added ✓';
            setTimeout(() => { addBtn.textContent = originalText; addBtn.disabled = false; }, 1600);
          } catch (err) {
            console.error('[pb-corp] add to cart failed:', err);
            addBtn.textContent = (err && err.message ? err.message : 'Try again').slice(0, 40);
            setTimeout(() => { addBtn.textContent = originalText; addBtn.disabled = false; }, 3000);
            /* Fire native cart:error event so the theme can surface it */
            document.dispatchEvent(new CustomEvent('cart:error', {
              bubbles: true,
              detail: {
                sourceId: section.id || 'pb-corp',
                data: { source: 'pb-corp-menu', message: err && err.message }
              }
            }));
          }
        });
      });

      const cart = section.querySelector('[data-pb-corp-cart]');
      const cartToggle = section.querySelector('[data-pb-corp-cart-toggle]');
      const cartClose = section.querySelector('[data-pb-corp-cart-close]');
      cartToggle?.addEventListener('click', () => (cart.hidden = !cart.hidden));
      cartClose?.addEventListener('click', () => (cart.hidden = true));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passion-gallery-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pb-gcarousel').forEach((section) => {
      const track = section.querySelector('[data-pb-gc-track]');
      const slides = Array.from(track.children);
      const prev = section.querySelector('[data-pb-gc-prev]');
      const next = section.querySelector('[data-pb-gc-next]');
      const playpause = section.querySelector('[data-pb-gc-playpause]');
      const dotsHost = section.querySelector('[data-pb-gc-dots]');
      const currentEl = section.querySelector('[data-pb-gc-current]');
      if (!track || slides.length === 0) return;

      const autoplay = section.dataset.autoplay === 'true';
      const direction = section.dataset.direction === 'to-right' ? -1 : 1;
      const speedMul = parseFloat(section.dataset.speed) || 5;

      // Compute slide widths after layout
      function slideWidth(i) {
        const s = slides[i] || slides[0];
        const style = getComputedStyle(s);
        const gap = parseFloat(getComputedStyle(track).gap) || 16;
        return s.getBoundingClientRect().width + gap;
      }

      // Build dots
      dotsHost.innerHTML = '';
      slides.forEach((s, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'pb-gcarousel__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', `Go to slide ${i + 1}`);
        d.addEventListener('click', () => goTo(i));
        dotsHost.appendChild(d);
      });
      const dots = Array.from(dotsHost.children);

      let activeIndex = 0;
      let paused = !autoplay;
      let timer = null;
      let pos = 0; // current translate X
      let raf = null;
      let lastTs = 0;

      function setActive(i) {
        activeIndex = ((i % slides.length) + slides.length) % slides.length;
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === activeIndex));
        if (currentEl) currentEl.textContent = String(activeIndex + 1).padStart(2, '0');
      }

      function goTo(i) {
        setActive(i);
        const target = -slideWidth(activeIndex) * activeIndex;
        pos = target;
        track.style.transition = 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
        track.style.transform = `translate3d(${pos}px, 0, 0)`;
        setTimeout(() => { track.style.transition = ''; }, 650);
      }

      prev && prev.addEventListener('click', () => goTo(activeIndex - 1));
      next && next.addEventListener('click', () => goTo(activeIndex + 1));

      // Smooth continuous autoplay (kinetic ticker style)
      const PX_PER_SEC = 18 + speedMul * 6; // 24 â†’ 78 px/sec
      function tick(ts) {
        if (!lastTs) lastTs = ts;
        const dt = (ts - lastTs) / 1000;
        lastTs = ts;
        if (!paused) {
          pos -= direction * PX_PER_SEC * dt;
          const w = slideWidth(0);
          // Wrap by relocating the first slide to the end when scrolled past it
          while (-pos >= w) {
            pos += w;
            track.appendChild(track.firstElementChild);
          }
          while (pos > 0) {
            pos -= w;
            track.insertBefore(track.lastElementChild, track.firstElementChild);
          }
          track.style.transform = `translate3d(${pos}px, 0, 0)`;
          // Update active index from translate
          const idx = Math.abs(Math.round(pos / w)) % slides.length;
          if (idx !== activeIndex) setActive(idx);
        }
        raf = requestAnimationFrame(tick);
      }

      if (autoplay) {
        raf = requestAnimationFrame(tick);
      }

      // Play/pause
      function setPaused(p) {
        paused = p;
        section.setAttribute('data-state', p ? 'paused' : 'playing');
        if (p) {
          if (playpause) playpause.setAttribute('aria-label', 'Play autoplay');
        } else {
          lastTs = 0;
          if (playpause) playpause.setAttribute('aria-label', 'Pause autoplay');
        }
      }
      setPaused(!autoplay);
      playpause && playpause.addEventListener('click', () => setPaused(!paused));

      // Pause on hover (desktop)
      section.addEventListener('mouseenter', () => { if (autoplay) setPaused(true); });
      section.addEventListener('mouseleave', () => { if (autoplay) setPaused(false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passion-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.pb-hero');
    sections.forEach((section) => {
      const slides = section.querySelectorAll('.pb-hero__slide');
      const dots = section.querySelectorAll('.pb-hero__dot');
      if (slides.length <= 1) return;

      const autoplay = section.dataset.autoplay === 'true';
      const speedSec = parseInt(section.dataset.autoplaySpeed, 10);
      const interval = (isNaN(speedSec) ? 6 : speedSec) * 1000;
      let current = 0;
      let timer = null;

      function goTo(i) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (i + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function next() { goTo(current + 1); }

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          goTo(i);
          if (timer && autoplay) {
            clearInterval(timer);
            timer = setInterval(next, interval);
          }
        });
      });

      if (autoplay) timer = setInterval(next, interval);

      // pause on hover
      section.addEventListener('mouseenter', () => { if (timer) clearInterval(timer); });
      section.addEventListener('mouseleave', () => {
        if (autoplay) { clearInterval(timer); timer = setInterval(next, interval); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passion-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pb-tiles').forEach((section) => {
      const viewport = section.querySelector('[data-pb-tiles]');
      const dotsHost = section.querySelector('[data-pb-tiles-dots]');
      const tiles = section.querySelectorAll('[data-pb-tile]');
      if (!viewport || !dotsHost || tiles.length === 0) return;

      // Build dots
      dotsHost.innerHTML = '';
      tiles.forEach((tile, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pb-tiles__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to tile ${i + 1}`);
        dot.addEventListener('click', () => {
          tile.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsHost.appendChild(dot);
      });
      const dots = dotsHost.querySelectorAll('.pb-tiles__dot');

      // Observe active tile via IntersectionObserver
      let activeIndex = 0;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const idx = Number(entry.target.getAttribute('data-pb-tile-index'));
            if (idx === activeIndex) return;
            activeIndex = idx;
            dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
          });
        },
        { root: viewport, threshold: 0.6 }
      );
      tiles.forEach((tile, i) => {
        tile.setAttribute('data-pb-tile-index', i);
        io.observe(tile);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passion-workshops"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pb-workshops [data-pb-ws-card]').forEach((card) => {
      const addBtn = card.querySelector('[data-pb-ws-add]');
      const qtyInput = card.querySelector('[data-pb-ws-qty]');
      const variantId = card.dataset.variantId;
      if (!addBtn || !variantId) return;

      addBtn.addEventListener('click', async () => {
        const qty = Math.max(parseInt(qtyInput && qtyInput.value || '1', 10) || 1, 1);
        addBtn.disabled = true;
        const original = addBtn.textContent;
        addBtn.textContent = 'Adding...';
        try {
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
          });
          if (!addRes.ok) {
            const errBody = await addRes.json().catch(() => ({}));
            throw new Error(errBody.description || errBody.message || ('Add failed (' + addRes.status + ')'));
          }
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cartData = cartRes.ok ? await cartRes.json() : null;

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartData,
              sourceId: 'pb-workshops',
              data: { source: 'pb-workshops', itemCount: cartData ? cartData.item_count : qty, variantId: String(variantId), didError: false }
            }
          }));

          const cartDrawer = document.querySelector('cart-drawer-component')
            || document.querySelector('cart-drawer')
            || document.querySelector('[ref="cartDrawer"]');
          if (cartDrawer) {
            const dialog = cartDrawer.querySelector('dialog');
            if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
              try { dialog.showModal(); } catch (e) { /* noop */ }
            } else if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (typeof cartDrawer.show === 'function') {
              cartDrawer.show();
            }
          }

          addBtn.textContent = 'Added ✓';
          setTimeout(() => { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
        } catch (err) {
          console.error('[pb-workshops] add to cart failed:', err);
          addBtn.textContent = (err && err.message ? err.message : 'Try again').slice(0, 40);
          setTimeout(() => { addBtn.textContent = original; addBtn.disabled = false; }, 3000);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
